import { render, staticRenderFns } from "./userdata.vue?vue&type=template&id=64886e29&"
import script from "./userdata.vue?vue&type=script&lang=js&"
export * from "./userdata.vue?vue&type=script&lang=js&"
import style0 from "./userdata.vue?vue&type=style&index=0&id=64886e29&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports